module.exports = __webpack_public_path__ + "img/lg_ring_r_c_0_0@2x.968bfaad.png";